export default __webpack_public_path__ + "static/media/right-mobile-black.a3382acc.svg";